import { Bookmark } from '@mui/icons-material'
import { SvgIconProps } from '@mui/material'
import React from 'react'

const TodoIconFilled = ({ iconColor, ...iconProps }: SvgIconProps & { iconColor?: string }) => (
  <Bookmark
    fontSize="large"
    {...iconProps}
    sx={{
      fill: iconColor,
      ...iconProps.sx
    }}
  />
)

export default TodoIconFilled
